import React from 'react';
import styled from '@emotion/styled';
import { Button } from '@material-ui/core';
import { typography, colors } from '@/styles';

export const H1 = styled.span`
    ${typography.sansSerif}

    font-weight: 800;
    font-size: 28px;
    line-height: 1.2;
`;

export const FilterButton = styled((props) => <Button variant="outlined" {...props} />)`
    ${typography.sansSerif}
    font-size: 14px;
    font-weight: 700;
    line-height: 1.25;
    text-transform: none;
    color: ${colors.greens.primary};
    background-color: ${colors.white.primary};
    border: 1px solid ${colors.greens.primary};
    min-width: 120px;
    height: 56px;

    &.MuiButton-root:hover {
        background-color: ${colors.greens.primary};
        color: ${colors.white.primary};
        border-color: ${colors.greens.primary};
    }
`;

export const Body1 = styled.span`
    ${typography.sansSerif}

    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
`;
